import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';

/*
 * This component is built using `gatsby-image` to automatically serve optimized
 * images with lazy loading and reduced file sizes. The image is loaded using a
 * `StaticQuery`, which allows us to load the image from directly within this
 * component, rather than having to pass the image data down from pages.
 *
 * For more information, see the docs:
 * - `gatsby-image`: https://gatsby.app/gatsby-image
 * - `StaticQuery`: https://gatsby.app/staticquery
 */

const Image = (props) => (
  <StaticQuery
    query={graphql`
      query {
        file(relativePath: { eq: "horticulture/bcp-green.png" }) {
          childImageSharp {
            fluid(maxHeight: 450) {
              ...GatsbyImageSharpFluid
            }
            fixed {
              src
            }
          }
        }
      }
    `}
    render={(data) => {
      return (
        <a href={data.file.childImageSharp.fixed.src}>
          <Img fluid={data.file.childImageSharp.fluid} {...props} />
        </a>
      );
    }}
  />
);
export default Image;
